import * as i5 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i2 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, PLATFORM_ID, numberAttribute, booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, ViewChild, ContentChildren, NgModule } from '@angular/core';
import * as i1 from 'primeng/api';
import { PrimeTemplate, SharedModule } from 'primeng/api';
import * as i3 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import { DomHandler } from 'primeng/dom';
import { AngleDoubleDownIcon } from 'primeng/icons/angledoubledown';
import { AngleDoubleUpIcon } from 'primeng/icons/angledoubleup';
import { AngleDownIcon } from 'primeng/icons/angledown';
import { AngleUpIcon } from 'primeng/icons/angleup';
import { SearchIcon } from 'primeng/icons/search';
import * as i4 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import { UniqueComponentId, ObjectUtils } from 'primeng/utils';

/**
 * OrderList is used to managed the order of a collection.
 * @group Components
 */
const _c0 = ["listelement"];
const _c1 = ["filter"];
const _c2 = (a0, a1, a2) => ({
  "p-orderlist p-component": true,
  "p-orderlist-striped": a0,
  "p-orderlist-controls-left": a1,
  "p-orderlist-controls-right": a2
});
const _c3 = a0 => ({
  options: a0
});
const _c4 = (a0, a1, a2) => ({
  "p-highlight": a0,
  "p-disabled": a1,
  "p-focus": a2
});
const _c5 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function OrderList_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
function OrderList_div_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderList_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, OrderList_div_8_div_1_Template, 2, 1, "div", 17)(2, OrderList_div_8_ng_container_2_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
  }
}
function OrderList_div_9_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderList_div_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderList_div_9_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.filterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, ctx_r1.filterOptions));
  }
}
function OrderList_div_9_ng_template_2_SearchIcon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 27);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-orderlist-filter-icon");
    i0.ɵɵattribute("data-pc-section", "filterIcon");
  }
}
function OrderList_div_9_ng_template_2_span_4_1_ng_template_0_Template(rf, ctx) {}
function OrderList_div_9_ng_template_2_span_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrderList_div_9_ng_template_2_span_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function OrderList_div_9_ng_template_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtemplate(1, OrderList_div_9_ng_template_2_span_4_1_Template, 1, 0, null, 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-pc-section", "filterIcon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.filterIconTemplate);
  }
}
function OrderList_div_9_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "input", 24, 2);
    i0.ɵɵlistener("keyup", function OrderList_div_9_ng_template_2_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFilterKeyup($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, OrderList_div_9_ng_template_2_SearchIcon_3_Template, 1, 2, "SearchIcon", 25)(4, OrderList_div_9_ng_template_2_span_4_Template, 2, 2, "span", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "filter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("placeholder", ctx_r1.filterPlaceholder)("aria-label", ctx_r1.ariaFilterLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.filterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.filterIconTemplate);
  }
}
function OrderList_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, OrderList_div_9_ng_container_1_Template, 2, 4, "ng-container", 21)(2, OrderList_div_9_ng_template_2_Template, 5, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const builtInFilterElement_r4 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "filterContainer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.filterTemplate)("ngIfElse", builtInFilterElement_r4);
  }
}
function OrderList_ng_template_12_li_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderList_ng_template_12_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵlistener("click", function OrderList_ng_template_12_li_0_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r5 = i0.ɵɵnextContext();
      const item_r7 = ctx_r5.$implicit;
      const i_r8 = ctx_r5.index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemClick($event, item_r7, i_r8, ctx_r1.id + "_" + i_r8));
    })("touchend", function OrderList_ng_template_12_li_0_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onItemTouchEnd());
    })("mousedown", function OrderList_ng_template_12_li_0_Template_li_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r8 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOptionMouseDown(i_r8));
    });
    i0.ɵɵtemplate(1, OrderList_ng_template_12_li_0_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const item_r7 = ctx_r5.$implicit;
    const i_r8 = ctx_r5.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.id + "_" + i_r8)("ngClass", i0.ɵɵpureFunction3(10, _c4, ctx_r1.isSelected(item_r7), ctx_r1.disabled, ctx_r1.id + "_" + i_r8 === ctx_r1.focusedOptionId()))("cdkDragData", item_r7)("cdkDragDisabled", !ctx_r1.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r1.isSelected(item_r7))("data-pc-section", "item")("data-p-highlight", ctx_r1.isSelected(item_r7))("data-p-focused", ctx_r1.id + "_" + i_r8 === ctx_r1.focusedOptionId());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(14, _c5, item_r7, i_r8));
  }
}
function OrderList_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrderList_ng_template_12_li_0_Template, 2, 17, "li", 29);
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.isItemVisible(item_r7));
  }
}
function OrderList_ng_container_13_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderList_ng_container_13_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 32);
    i0.ɵɵtemplate(1, OrderList_ng_container_13_li_1_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "emptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyMessageTemplate);
  }
}
function OrderList_ng_container_13_li_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderList_ng_container_13_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 32);
    i0.ɵɵtemplate(1, OrderList_ng_container_13_li_2_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "emptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyFilterMessageTemplate);
  }
}
function OrderList_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderList_ng_container_13_li_1_Template, 2, 2, "li", 31)(2, OrderList_ng_container_13_li_2_Template, 2, 2, "li", 31);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.filterValue || !ctx_r1.emptyFilterMessageTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.filterValue);
  }
}
let OrderList = /*#__PURE__*/(() => {
  class OrderList {
    document;
    platformId;
    renderer;
    el;
    cd;
    filterService;
    config;
    /**
     * Hinweistext für Screenreader, wie Elemente selektiert werden können
     * @group Props
     */
    selectionDescription;
    /**
     * Hinweistext für Screenreader, um Erfolgsmeldungen für das Verschieben von Elementen ausgeben zu können
     * @group Props
     */
    movingHint;
    /**
     * Defines a string that labels the move to up button for accessibility.
     * @group Props
     */
    upButtonAriaLabel;
    /**
     * Defines a string that labels the move to down button for accessibility.
     * @group Props
     */
    downButtonAriaLabel;
    /**
     * Defines a string that labels the move to top button for accessibility.
     * @group Props
     */
    topButtonAriaLabel;
    /**
     * Defines a string that labels the move to bottom button for accessibility.
     * @group Props
     */
    bottomButtonAriaLabel;
    /**
     * Text for the caption.
     * @group Props
     */
    header;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex;
    /**
     * Defines a string that labels the input for accessibility.
     * @group Props
     */
    ariaLabel;
    /**
     * Specifies one or more IDs in the DOM that labels the input field.
     * @group Props
     */
    ariaLabelledBy;
    /**
     * Inline style of the list element.
     * @group Props
     */
    listStyle;
    /**
     * A boolean value that indicates whether the component should be responsive.
     * @group Props
     */
    responsive;
    /**
     * When specified displays an input field to filter the items on keyup and decides which fields to search against.
     * @group Props
     */
    filterBy;
    /**
     * Placeholder of the filter input.
     * @group Props
     */
    filterPlaceholder;
    /**
     * Locale to use in filtering. The default locale is the host environment's current locale.
     * @group Props
     */
    filterLocale;
    /**
     * When true metaKey needs to be pressed to select or unselect an item and when set to false selection of each item can be toggled individually. On touch enabled devices, metaKeySelection is turned off automatically.
     * @group Props
     */
    metaKeySelection = false;
    /**
     * Whether to enable dragdrop based reordering.
     * @group Props
     */
    dragdrop = false;
    /**
     * Defines the location of the buttons with respect to the list.
     * @group Props
     */
    controlsPosition = 'left';
    /**
     * Defines a string that labels the filter input.
     * @group Props
     */
    ariaFilterLabel;
    /**
     * Defines how the items are filtered.
     * @group Props
     */
    filterMatchMode = 'contains';
    /**
     * Indicates the width of the screen at which the component should change its behavior.
     * @group Props
     */
    breakpoint = '960px';
    /**
     * Whether to displays rows with alternating colors.
     * @group Props
     */
    stripedRows;
    /**
     * When present, it specifies that the component should be disabled.
     * @group Props
     */
    disabled = false;
    /**
     * Function to optimize the dom operations by delegating to ngForTrackBy, default algorithm checks for object identity.
     * @group Props
     */
    trackBy = (index, item) => item;
    /**
     * A list of values that are currently selected.
     * @group Props
     */
    set selection(val) {
      this.d_selection = val;
    }
    get selection() {
      return this.d_selection;
    }
    /**
     * Array of values to be displayed in the component.
     * It represents the data source for the list of items.
     * @group Props
     */
    set value(val) {
      this._value = val;
      if (this.filterValue) {
        this.filter();
      }
    }
    get value() {
      return this._value;
    }
    /**
     * Callback to invoke on selection change.
     * @param {*} any - selection instance.
     * @group Emits
     */
    selectionChange = new EventEmitter();
    /**
     * Callback to invoke when list is reordered.
     * @param {*} any - list instance.
     * @group Emits
     */
    onReorder = new EventEmitter();
    /**
     * Callback to invoke when selection changes.
     * @param {OrderListSelectionChangeEvent} event - Custom change event.
     * @group Emits
     */
    onSelectionChange = new EventEmitter();
    /**
     * Callback to invoke when filtering occurs.
     * @param {OrderListFilterEvent} event - Custom filter event.
     * @group Emits
     */
    onFilterEvent = new EventEmitter();
    /**
     * Callback to invoke when the list is focused
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    /**
     * Callback to invoke when the list is blurred
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    listViewChild;
    filterViewChild;
    templates;
    itemTemplate;
    headerTemplate;
    emptyMessageTemplate;
    emptyFilterMessageTemplate;
    filterTemplate;
    get moveUpAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.moveUp : undefined;
    }
    get moveTopAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.moveTop : undefined;
    }
    get moveDownAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.moveDown : undefined;
    }
    get moveBottomAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.moveBottom : undefined;
    }
    moveUpIconTemplate;
    moveTopIconTemplate;
    moveDownIconTemplate;
    moveBottomIconTemplate;
    filterIconTemplate;
    filterOptions;
    d_selection = [];
    movedUp;
    movedDown;
    itemTouched;
    styleElement;
    id = UniqueComponentId();
    focused = false;
    focusedOptionIndex = -1;
    focusedOption;
    filterValue;
    visibleOptions;
    _value;
    constructor(document, platformId, renderer, el, cd, filterService, config) {
      this.document = document;
      this.platformId = platformId;
      this.renderer = renderer;
      this.el = el;
      this.cd = cd;
      this.filterService = filterService;
      this.config = config;
    }
    ngOnInit() {
      if (this.responsive) {
        this.createStyle();
      }
      if (this.filterBy) {
        this.filterOptions = {
          filter: value => this.onFilterKeyup(value),
          reset: () => this.resetFilter()
        };
      }
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'item':
            this.itemTemplate = item.template;
            break;
          case 'empty':
            this.emptyMessageTemplate = item.template;
            break;
          case 'emptyfilter':
            this.emptyFilterMessageTemplate = item.template;
            break;
          case 'filter':
            this.filterTemplate = item.template;
            break;
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'moveupicon':
            this.moveUpIconTemplate = item.template;
            break;
          case 'movetopicon':
            this.moveTopIconTemplate = item.template;
            break;
          case 'movedownicon':
            this.moveDownIconTemplate = item.template;
            break;
          case 'movebottomicon':
            this.moveBottomIconTemplate = item.template;
            break;
          case 'filtericon':
            this.filterIconTemplate = item.template;
            break;
          default:
            this.itemTemplate = item.template;
            break;
        }
      });
    }
    ngAfterViewChecked() {
      if (this.movedUp || this.movedDown) {
        let listItems = DomHandler.find(this.listViewChild?.nativeElement, 'li.p-highlight');
        let listItem;
        if (listItems.length > 0) {
          if (this.movedUp) listItem = listItems[0];else listItem = listItems[listItems.length - 1];
          DomHandler.scrollInView(this.listViewChild?.nativeElement, listItem);
        }
        this.movedUp = false;
        this.movedDown = false;
      }
    }
    onItemClick(event, item, index, selectedId) {
      this.itemTouched = false;
      let focusedIndex = index ? index : ObjectUtils.findIndexInList(this.focusedOption, this.value);
      let selectedIndex = ObjectUtils.findIndexInList(item, this.d_selection);
      let selected = selectedIndex !== -1;
      let metaSelection = this.itemTouched ? false : this.metaKeySelection;
      if (selectedId) {
        this.focusedOptionIndex = selectedId;
      }
      if (metaSelection) {
        let metaKey = event.metaKey || event.ctrlKey;
        if (selected && metaKey) {
          this.d_selection = this.d_selection.filter((val, focusedIndex) => focusedIndex !== selectedIndex);
        } else {
          this.d_selection = metaKey ? this.d_selection ? [...this.d_selection] : [] : [];
          ObjectUtils.insertIntoOrderedArray(item, focusedIndex, this.d_selection, this.value);
        }
      } else {
        if (selected) {
          this.d_selection = this.d_selection.filter((val, focusedIndex) => focusedIndex !== selectedIndex);
        } else {
          this.d_selection = this.d_selection ? [...this.d_selection] : [];
          ObjectUtils.insertIntoOrderedArray(item, focusedIndex, this.d_selection, this.value);
        }
      }
      //binding
      this.selectionChange.emit(this.d_selection);
      //event
      this.onSelectionChange.emit({
        originalEvent: event,
        value: this.d_selection
      });
    }
    onFilterKeyup(event) {
      this.filterValue = event.target.value.trim().toLocaleLowerCase(this.filterLocale);
      this.filter();
      this.onFilterEvent.emit({
        originalEvent: event,
        value: this.visibleOptions
      });
    }
    filter() {
      let searchFields = this.filterBy.split(',');
      this.visibleOptions = this.filterService.filter(this.value, searchFields, this.filterValue, this.filterMatchMode, this.filterLocale);
    }
    /**
     * Callback to invoke on filter reset.
     * @group Method
     */
    resetFilter() {
      this.filterValue = null;
      this.filterViewChild && (this.filterViewChild.nativeElement.value = '');
    }
    isItemVisible(item) {
      if (this.filterValue && this.filterValue.trim().length) {
        for (let i = 0; i < this.visibleOptions.length; i++) {
          if (item == this.visibleOptions[i]) {
            return true;
          }
        }
      } else {
        return true;
      }
    }
    onItemTouchEnd() {
      this.itemTouched = true;
    }
    isSelected(item) {
      return ObjectUtils.findIndexInList(item, this.d_selection) !== -1;
    }
    isEmpty() {
      return this.filterValue ? !this.visibleOptions || this.visibleOptions.length === 0 : !this.value || this.value.length === 0;
    }
    moveUp() {
      if (this.selection) {
        for (let i = 0; i < this.selection.length; i++) {
          let selectedItem = this.selection[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, this.value);
          if (selectedItemIndex != 0 && this.value instanceof Array) {
            let movedItem = this.value[selectedItemIndex];
            let temp = this.value[selectedItemIndex - 1];
            this.value[selectedItemIndex - 1] = movedItem;
            this.value[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        if (this.dragdrop && this.filterValue) this.filter();
        this.movedUp = true;
        this.onReorder.emit(this.selection);
        this.movedText();
      }
    }
    moveTop() {
      if (this.selection) {
        for (let i = this.selection.length - 1; i >= 0; i--) {
          let selectedItem = this.selection[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, this.value);
          if (selectedItemIndex != 0 && this.value instanceof Array) {
            let movedItem = this.value.splice(selectedItemIndex, 1)[0];
            this.value.unshift(movedItem);
          } else {
            break;
          }
        }
        if (this.dragdrop && this.filterValue) this.filter();
        this.onReorder.emit(this.selection);
        this.listViewChild.nativeElement.scrollTop = 0;
        this.movedText();
      }
    }
    moveDown() {
      if (this.selection) {
        for (let i = this.selection.length - 1; i >= 0; i--) {
          let selectedItem = this.selection[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, this.value);
          if (this.value instanceof Array && selectedItemIndex != this.value.length - 1) {
            let movedItem = this.value[selectedItemIndex];
            let temp = this.value[selectedItemIndex + 1];
            this.value[selectedItemIndex + 1] = movedItem;
            this.value[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        if (this.dragdrop && this.filterValue) this.filter();
        this.movedDown = true;
        this.onReorder.emit(this.selection);
        this.movedText();
      }
    }
    moveBottom() {
      if (this.selection) {
        for (let i = 0; i < this.selection.length; i++) {
          let selectedItem = this.selection[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, this.value);
          if (this.value instanceof Array && selectedItemIndex != this.value.length - 1) {
            let movedItem = this.value.splice(selectedItemIndex, 1)[0];
            this.value.push(movedItem);
          } else {
            break;
          }
        }
        if (this.dragdrop && this.filterValue) this.filter();
        this.onReorder.emit(this.selection);
        this.listViewChild.nativeElement.scrollTop = this.listViewChild?.nativeElement.scrollHeight;
        this.movedText();
      }
    }
    movedText() {
      let hintText = document.getElementById('movingHint');
      hintText.innerHTML = this.movingHint;
      setTimeout(() => {
        hintText.innerHTML = '';
      }, 500);
    }
    onDrop(event) {
      let previousIndex = event.previousIndex;
      let currentIndex = event.currentIndex;
      if (previousIndex !== currentIndex) {
        if (this.visibleOptions) {
          if (this.filterValue) {
            previousIndex = ObjectUtils.findIndexInList(event.item.data, this.value);
            currentIndex = ObjectUtils.findIndexInList(this.visibleOptions[currentIndex], this.value);
          }
          moveItemInArray(this.visibleOptions, event.previousIndex, event.currentIndex);
        }
        moveItemInArray(this.value, previousIndex, currentIndex);
        this.changeFocusedOptionIndex(currentIndex);
        this.onReorder.emit([event.item.data]);
      }
    }
    onListFocus(event) {
      const focusableEl = DomHandler.findSingle(this.listViewChild.nativeElement, '[data-p-highlight="true"]') || DomHandler.findSingle(this.listViewChild.nativeElement, '[data-pc-section="item"]');
      if (focusableEl) {
        const findIndex = ObjectUtils.findIndexInList(focusableEl, this.listViewChild.nativeElement.children);
        this.focused = true;
        const index = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : focusableEl ? findIndex : -1;
        this.changeFocusedOptionIndex(index);
      }
      this.onFocus.emit(event);
    }
    onListBlur(event) {
      this.focused = false;
      this.focusedOption = null;
      this.focusedOptionIndex = -1;
      this.onBlur.emit(event);
    }
    onItemKeydown(event) {
      const targetTagName = event.target.tagName.toLowerCase();
      if (targetTagName == 'input') {
        return;
      }
      switch (event.code) {
        case 'ArrowDown':
          this.onArrowDownKey(event);
          break;
        case 'ArrowUp':
          this.onArrowUpKey(event);
          break;
        case 'Home':
          this.onHomeKey(event);
          break;
        case 'End':
          this.onEndKey(event);
          break;
        case 'Enter':
          this.onEnterKey(event);
          break;
        case 'Space':
          this.onSpaceKey(event);
          break;
        case 'KeyA':
          if (event.ctrlKey) {
            this.d_selection = [...this.value];
            this.selectionChange.emit(this.d_selection);
          }
        default:
          break;
      }
    }
    focusElementByIndex(index) {
      const elementId = this.id + '_' + index;
      const element = document.getElementById(elementId);
      if (element) {
        element.focus();
      }
    }
    onOptionMouseDown(index) {
      this.focused = true;
      this.focusedOptionIndex = index;
    }
    onArrowDownKey(event) {
      const optionIndex = this.findNextOptionIndex(this.focusedOptionIndex);
      this.changeFocusedOptionIndex(optionIndex);
      this.focusElementByIndex(optionIndex);
      if (event.shiftKey) {
        this.onEnterKey(event);
      }
      event.preventDefault();
    }
    onArrowUpKey(event) {
      const optionIndex = this.findPrevOptionIndex(this.focusedOptionIndex);
      this.changeFocusedOptionIndex(optionIndex);
      this.focusElementByIndex(optionIndex);
      if (event.shiftKey) {
        this.onEnterKey(event);
      }
      event.preventDefault();
    }
    onHomeKey(event) {
      if (event.ctrlKey && event.shiftKey) {
        let visibleOptions = this.getVisibleOptions();
        let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleOptions);
        this.d_selection = [...this.value].slice(0, focusedIndex + 1);
        this.selectionChange.emit(this.d_selection);
      } else {
        this.changeFocusedOptionIndex(0);
      }
      event.preventDefault();
    }
    onEndKey(event) {
      if (event.ctrlKey && event.shiftKey) {
        let visibleOptions = this.getVisibleOptions();
        let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleOptions);
        this.d_selection = [...this.value].slice(focusedIndex, visibleOptions.length - 1);
        this.selectionChange.emit(this.d_selection);
      } else {
        this.changeFocusedOptionIndex(DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="item"]').length - 1);
      }
      event.preventDefault();
    }
    onEnterKey(event) {
      this.onItemClick(event, this.focusedOption);
      event.preventDefault();
    }
    onSpaceKey(event) {
      event.preventDefault();
      if (event.shiftKey && this.selection && this.selection.length > 0) {
        let visibleOptions = this.getVisibleOptions();
        let lastSelectedIndex = this.getLatestSelectedVisibleOptionIndex(visibleOptions);
        if (lastSelectedIndex !== -1) {
          let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleOptions);
          this.d_selection = [...visibleOptions.slice(Math.min(lastSelectedIndex, focusedIndex), Math.max(lastSelectedIndex, focusedIndex) + 1)];
          this.selectionChange.emit(this.d_selection);
          this.onSelectionChange.emit({
            originalEvent: event,
            value: this.d_selection
          });
          return;
        }
      }
      this.onEnterKey(event);
    }
    findNextOptionIndex(index) {
      const items = DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="item"]');
      const matchedOptionIndex = [...items].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex + 1 : 0;
    }
    findPrevOptionIndex(index) {
      const items = DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="item"]');
      const matchedOptionIndex = [...items].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex - 1 : 0;
    }
    getLatestSelectedVisibleOptionIndex(visibleOptions) {
      const latestSelectedItem = [...this.d_selection].reverse().find(item => visibleOptions.includes(item));
      return latestSelectedItem !== undefined ? visibleOptions.indexOf(latestSelectedItem) : -1;
    }
    getVisibleOptions() {
      return this.visibleOptions && this.visibleOptions.length > 0 ? this.visibleOptions : this.value && this.value.length > 0 ? this.value : null;
    }
    getFocusedOption(index) {
      if (index === -1) return null;
      return this.visibleOptions && this.visibleOptions.length ? this.visibleOptions[index] : this.value && this.value.length ? this.value[index] : null;
    }
    changeFocusedOptionIndex(index) {
      const items = DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="item"]');
      let order = index >= items.length ? items.length - 1 : index < 0 ? 0 : index;
      this.focusedOptionIndex = items[order] ? items[order].getAttribute('id') : -1;
      this.focusedOption = this.getFocusedOption(order);
      this.scrollInView(this.focusedOptionIndex);
    }
    scrollInView(id) {
      const element = DomHandler.findSingle(this.listViewChild.nativeElement, `[data-pc-section="item"][id="${id}"]`);
      if (element) {
        element.scrollIntoView && element.scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
    findNextItem(item) {
      let nextItem = item.nextElementSibling;
      if (nextItem) return !DomHandler.hasClass(nextItem, 'p-orderlist-item') || DomHandler.isHidden(nextItem) ? this.findNextItem(nextItem) : nextItem;else return null;
    }
    findPrevItem(item) {
      let prevItem = item.previousElementSibling;
      if (prevItem) return !DomHandler.hasClass(prevItem, 'p-orderlist-item') || DomHandler.isHidden(prevItem) ? this.findPrevItem(prevItem) : prevItem;else return null;
    }
    moveDisabled() {
      if (this.disabled || !this.selection.length) {
        return true;
      }
    }
    focusedOptionId() {
      return this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : null;
    }
    createStyle() {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.styleElement) {
          this.renderer.setAttribute(this.el.nativeElement.children[0], this.id, '');
          this.styleElement = this.renderer.createElement('style');
          this.renderer.setAttribute(this.styleElement, 'type', 'text/css');
          DomHandler.setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
          this.renderer.appendChild(this.document.head, this.styleElement);
          let innerHTML = `
                    @media screen and (max-width: ${this.breakpoint}) {
                        .p-orderlist[${this.id}] {
                            flex-direction: column;
                        }

                        .p-orderlist[${this.id}] .p-orderlist-controls {
                            padding: var(--content-padding);
                            flex-direction: row;
                        }

                        .p-orderlist[${this.id}] .p-orderlist-controls .p-button {
                            margin-right: var(--inline-spacing);
                            margin-bottom: 0;
                        }

                        .p-orderlist[${this.id}] .p-orderlist-controls .p-button:last-child {
                            margin-right: 0;
                        }
                    }
                `;
          this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
        }
      }
    }
    destroyStyle() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.styleElement) {
          this.renderer.removeChild(this.document, this.styleElement);
          this.styleElement = null;
          ``;
        }
      }
    }
    ngOnDestroy() {
      this.destroyStyle();
    }
    static ɵfac = function OrderList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderList)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.PrimeNGConfig));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderList,
      selectors: [["p-orderList"]],
      contentQueries: function OrderList_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function OrderList_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        selectionDescription: "selectionDescription",
        movingHint: "movingHint",
        upButtonAriaLabel: "upButtonAriaLabel",
        downButtonAriaLabel: "downButtonAriaLabel",
        topButtonAriaLabel: "topButtonAriaLabel",
        bottomButtonAriaLabel: "bottomButtonAriaLabel",
        header: "header",
        style: "style",
        styleClass: "styleClass",
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        ariaLabel: "ariaLabel",
        ariaLabelledBy: "ariaLabelledBy",
        listStyle: "listStyle",
        responsive: [2, "responsive", "responsive", booleanAttribute],
        filterBy: "filterBy",
        filterPlaceholder: "filterPlaceholder",
        filterLocale: "filterLocale",
        metaKeySelection: [2, "metaKeySelection", "metaKeySelection", booleanAttribute],
        dragdrop: [2, "dragdrop", "dragdrop", booleanAttribute],
        controlsPosition: "controlsPosition",
        ariaFilterLabel: "ariaFilterLabel",
        filterMatchMode: "filterMatchMode",
        breakpoint: "breakpoint",
        stripedRows: [2, "stripedRows", "stripedRows", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        trackBy: "trackBy",
        selection: "selection",
        value: "value"
      },
      outputs: {
        selectionChange: "selectionChange",
        onReorder: "onReorder",
        onSelectionChange: "onSelectionChange",
        onFilterEvent: "onFilterEvent",
        onFocus: "onFocus",
        onBlur: "onBlur"
      },
      standalone: false,
      features: [i0.ɵɵInputTransformsFeature],
      decls: 14,
      vars: 40,
      consts: [["listelement", ""], ["builtInFilterElement", ""], ["filter", ""], [3, "ngClass", "ngStyle"], [1, "p-orderlist-controls"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-up", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-double-up", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-down", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-double-down", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["id", "movingHint", "aria-live", "polite", 1, "visibilityOnlyForScreenreader"], [1, "p-orderlist-list-container"], ["class", "p-orderlist-header", 4, "ngIf"], ["class", "p-orderlist-filter-container", 4, "ngIf"], ["cdkDropList", "", "role", "listbox", "aria-multiselectable", "true", 1, "p-orderlist-list", 3, "cdkDropListDropped", "focus", "blur", "keydown", "id", "ngStyle", "tabindex"], ["ngFor", "", 3, "ngForTrackBy", "ngForOf"], [4, "ngIf"], [1, "p-orderlist-header"], ["class", "p-orderlist-title", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "p-orderlist-title"], [1, "p-orderlist-filter-container"], [4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-orderlist-filter"], ["type", "text", "role", "textbox", 1, "p-orderlist-filter-input", "p-inputtext", "p-component", 3, "keyup", "disabled"], [3, "styleClass", 4, "ngIf"], ["class", "p-orderlist-filter-icon", 4, "ngIf"], [3, "styleClass"], [1, "p-orderlist-filter-icon"], ["pRipple", "", "cdkDrag", "", "role", "option", "class", "p-orderlist-item", "tabindex", "0", 3, "id", "ngClass", "cdkDragData", "cdkDragDisabled", "click", "touchend", "mousedown", 4, "ngIf"], ["pRipple", "", "cdkDrag", "", "role", "option", "tabindex", "0", 1, "p-orderlist-item", 3, "click", "touchend", "mousedown", "id", "ngClass", "cdkDragData", "cdkDragDisabled"], ["class", "p-orderlist-empty-message", 4, "ngIf"], [1, "p-orderlist-empty-message"]],
      template: function OrderList_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "button", 5);
          i0.ɵɵlistener("click", function OrderList_Template_button_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveUp());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "button", 6);
          i0.ɵɵlistener("click", function OrderList_Template_button_click_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveTop());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "button", 7);
          i0.ɵɵlistener("click", function OrderList_Template_button_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveDown());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "button", 8);
          i0.ɵɵlistener("click", function OrderList_Template_button_click_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveBottom());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(6, "div", 9);
          i0.ɵɵelementStart(7, "div", 10);
          i0.ɵɵtemplate(8, OrderList_div_8_Template, 3, 3, "div", 11)(9, OrderList_div_9_Template, 4, 3, "div", 12);
          i0.ɵɵelementStart(10, "ul", 13, 0);
          i0.ɵɵlistener("cdkDropListDropped", function OrderList_Template_ul_cdkDropListDropped_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDrop($event));
          })("focus", function OrderList_Template_ul_focus_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListFocus($event));
          })("blur", function OrderList_Template_ul_blur_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListBlur($event));
          })("keydown", function OrderList_Template_ul_keydown_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onItemKeydown($event));
          });
          i0.ɵɵtemplate(12, OrderList_ng_template_12_Template, 1, 1, "ng-template", 14)(13, OrderList_ng_container_13_Template, 3, 2, "ng-container", 15);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(36, _c2, ctx.stripedRows, ctx.controlsPosition === "left", ctx.controlsPosition === "right"))("ngStyle", ctx.style);
          i0.ɵɵattribute("data-pc-section", "root");
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "controls");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveDisabled());
          i0.ɵɵattribute("aria-label", ctx.upButtonAriaLabel)("title", ctx.upButtonAriaLabel)("data-pc-section", "moveUpButton");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveDisabled());
          i0.ɵɵattribute("aria-label", ctx.topButtonAriaLabel)("title", ctx.topButtonAriaLabel)("data-pc-section", "moveTopButton");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveDisabled());
          i0.ɵɵattribute("aria-label", ctx.downButtonAriaLabel)("title", ctx.downButtonAriaLabel)("data-pc-section", "moveDownButton");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveDisabled());
          i0.ɵɵattribute("aria-label", ctx.bottomButtonAriaLabel)("title", ctx.bottomButtonAriaLabel)("data-pc-section", "moveBottomButton");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("data-pc-section", "container");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.header || ctx.headerTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterBy);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.id + "_list")("ngStyle", ctx.listStyle)("tabindex", ctx.tabindex);
          i0.ɵɵattribute("data-pc-section", "list")("aria-activedescendant", ctx.focused ? ctx.focusedOptionId() : undefined)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledBy)("aria-description", ctx.selectionDescription);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForTrackBy", ctx.trackBy)("ngForOf", ctx.value);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEmpty() && (ctx.emptyMessageTemplate || ctx.emptyFilterMessageTemplate));
        }
      },
      dependencies: () => [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, i3.ButtonDirective, i4.Ripple, i5.CdkDropList, i5.CdkDrag, SearchIcon],
      styles: [".p-orderlist{display:flex}.p-orderlist-controls{display:flex;flex-direction:column;justify-content:center}.p-orderlist-list-container{flex:1 1 auto}.p-orderlist-list{list-style-type:none;margin:0;padding:0;overflow:auto;min-height:12rem}.p-orderlist-item{display:block;cursor:pointer;overflow:hidden;position:relative}.p-orderlist-item:not(.cdk-drag-disabled){cursor:move}.p-orderlist-item.cdk-drag-placeholder{opacity:0}.p-orderlist-item.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.p-orderlist.p-state-disabled .p-orderlist-item,.p-orderlist.p-state-disabled .p-button{cursor:default}.p-orderlist.p-state-disabled .p-orderlist-list{overflow:hidden}.p-orderlist-filter{position:relative}.p-orderlist-filter-icon{position:absolute;top:50%;margin-top:-.5rem;cursor:pointer}.p-orderlist-filter-input{width:100%}.p-orderlist-controls-right .p-orderlist-controls{order:2}.p-orderlist-controls-right .p-orderlist-list-container{order:1}.p-orderlist-list.cdk-drop-list-dragging .p-orderlist-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return OrderList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrderListModule = /*#__PURE__*/(() => {
  class OrderListModule {
    static ɵfac = function OrderListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderListModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderListModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ButtonModule, SharedModule, RippleModule, DragDropModule, AngleDoubleDownIcon, AngleDoubleUpIcon, AngleUpIcon, AngleDownIcon, SearchIcon, SharedModule, DragDropModule]
    });
  }
  return OrderListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OrderList, OrderListModule };
